function validPhone (data) {
  const reg = /((?=(09))\d{10})$/
  const status = reg.test(data)
  return status
}

function validIP (data) {
  const reg = /^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/
  const status = reg.test(data)
  return status
}

/**
 * valid  car index
 */
function validCarIndex (data) {
  const reg = /^[A-Z\d]{2,3}-\d{3,4}$|^\d{3,4}-[A-Z\d]{2,3}$/

  const status = reg.test(data)
  return status
}

function hashFnv32a (str, seed) {
  /* jshint bitwise:false */
  let hval = seed === undefined ? 0x811c9dc5 : seed

  for (let i = 0; i < str.length; i++) {
    hval ^= str.charCodeAt(i)
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24)
  }
  // Convert to 8 digit hex string
  return ('0000000' + (hval >>> 0).toString(16)).slice(-8)
}

function indexPad (n, width, z) {
  width = width || 3
  z = z || '0'
  n = n + ''
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}

function numberWithCommas (num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export { hashFnv32a, validPhone, validIP, validCarIndex, indexPad, numberWithCommas }
